import styled from "styled-components";
import { Typography } from "@mui/material";
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";

import pages from "../../constants/pages";
import { colors } from "../css components/Style";
import { useAxios, useComponent } from "../../hooks";
import { alert } from "../../redux/slices/alertSlice";
import Logo from "../../assets/grow_logo-removebg-preview.png";
import { signOutMember } from "../../redux/slices/memberSlice";
import WelcomeCardAgency from "./login user components/WelcomeCardsAgency";

const Wrapper = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
`;

const InnerWrapper = styled.div`
  padding: 40px;
  text-align: center;
  height: calc(100% - 50px);
`;

const Typo = styled(Typography)`
  font-weight: 400;
  font-size: 1.5rem;
  margin-top: 10px;
`;

export default function WelcomeAsAgency() {
  const axios = useAxios();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { loader } = useComponent();

  const [steps, setStep] = useState({});
  const [status, setStatus] = useState(false);
  const [verification, setVerification] = useState({
    agency: false,
    admin: false,
  });

  const userID = sessionStorage.getItem("userID");
  const agencyID = sessionStorage.getItem("agencyID");

  useEffect(() => {
    axios({
      url: "/user/info?userId=" + userID,
      disableRedirect: true,
    }).then((res) => {
      if (res.status) {
        sessionStorage.setItem("ladder", JSON.stringify(res.data?.steps));
        setStep(res.data.steps);
        if (parseInt(res.data.brand?.brand_id) === parseInt(agencyID)) {
          if (res.data.brand?.is_brand_verified === 1) {
            setVerification({
              agency: true,
            });
          }
          if (res.data.brand?.is_brand_verified === 2) {
            dispatch(
              alert({
                type: "info",
                message: "Agency has been rejected by the admin!",
              })
            );
            dispatch(signOutMember());
            navigate(pages.signIn.route);
          }
        }
      }
    });
  }, [axios, userID, loader, dispatch, navigate, agencyID]);

  function checkStatus() {
    setStatus(true);
    axios({
      url: "/user/info?userId=" + userID,
      disableRedirect: true,
    }).then((res) => {
      if (res.status) {
        if (parseInt(res.data.agency?.agency_id) === parseInt(agencyID)) {
          if (res.data.agency?.is_agency_verified === 0) {
            let message = "Agency hasn't been approved by the admin yet!";

            if (
              !res.data.agency?.get_agreement ||
              !res.data.agency?.sign_agreement
            ) {
              message = "Agency hasn't been approved by the admin yet!";
            }

            dispatch(
              alert({
                type: "warning",
                message: message,
              })
            );
          }

          if (res.data.agency?.is_agency_verified === 1) {
            setVerification({
              agency: true,
            });

            dispatch(
              alert({
                type: "success",
                message: "Agency has been approved by the admin!",
              })
            );

            dispatch(signOutMember());
            navigate(pages.signIn.route);
          }
          if (res.data.agency?.is_agency_verified === 2) {
            dispatch(
              alert({
                type: "info",
                message: "Agency has been rejected by the admin!",
              })
            );
            dispatch(signOutMember());
            navigate(pages.signIn.route);
          }
        }
        setStatus(false);
      }
    });
  }

  return (
    <Wrapper>
      <InnerWrapper>
        <Typo>Agency Details</Typo>
        <Typography fontSize={"20px"} className="font">
          Fill in the essential information to set up your agency profile.
        </Typography>

        <WelcomeCardAgency steps={steps} verification={verification} />

        {steps.step2 && !verification.agency && (
          <div className="admin-status">
            <Typography
              style={{
                textAlign: "center",
                fontWeight: "600",
              }}
            >
              Your account is waiting for the admin approval!
              <Typography
                style={{ cursor: "pointer" }}
                variant="button"
                color={colors.publicisBlue}
                onClick={checkStatus}
                disabled={status}
              >
                {" "}
                Click to check status.
              </Typography>
            </Typography>
          </div>
        )}

        {steps.step2 && steps.step3 && verification.agency && (
          <div className="admin-approve-status">
            <Typography
              style={{
                textAlign: "center",
                fontWeight: "600",
              }}
            >
              Your account has been approved by the admin. Click here to{" "}
              <Typography
                style={{ cursor: "pointer" }}
                variant="button"
                color={colors.publicisBlue}
                onClick={() => {
                  dispatch(signOutMember());
                  navigate(pages.signIn.route);
                }}
              >
                Login
              </Typography>
            </Typography>
          </div>
        )}

        <div
          className="bottom-div"
          style={{
            position: "absolute",
            bottom: "30px",
            left: 0,
            right: 0,
            display: "flex",
            justifyContent: "space-between",
            padding: "0 40px",
          }}
        >
          <div />
          <div className="footer-branding">
            <span>Powered by</span>
            <div className="growth-os-logo">
              <img
                src={Logo}
                alt="1"
                style={{ height: "25px", position: "relative", top: "-3px" }}
              />
            </div>
          </div>
        </div>
      </InnerWrapper>
    </Wrapper>
  );
}
